// src/utils/attendanceStatus.js

/**
 * Check if an employee is present (has checked in today)
 */
export const isPresent = (attendance) => {
   return !!attendance?.checkIn;
};

/**
 * Check if an employee is absent (has not checked in today)
 */
export const isAbsent = (attendance) => {
   return !attendance?.checkIn;
};

/**
 * Check if an employee has checked out
 */
export const isCheckedOut = (attendance) => {
   return !!attendance?.checkOut;
};

/**
 * Check if an employee is currently working (checked in, not checked out)
 */
export const isWorking = (attendance) => {
   return attendance?.checkIn && !attendance?.checkOut;
};
